const PolicyPage = () => {
  return (
    <>
      <div style={{ height: "100vh", width: "100vw", background: "#FFFFFF" }}>
        <iframe
          src="/policy.html"
          width="100%"
          height="100%"
          title="개인정보약관"
        />
      </div>
    </>
  );
};

export default PolicyPage;
